import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

import { endpoints } from '../api/endpoints';
import { RootState } from '../store/store';
import { setUser } from '../store/userSlice';

/** Wait for App whoami / session restore before auth route guards redirect. */
export function useAuthSessionReady(): boolean {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user.user);
  const [authReady, setAuthReady] = useState(() => Boolean(user));

  useEffect(() => {
    if (user) {
      setAuthReady(true);
      return;
    }

    let isMounted = true;
    axios
      .get(endpoints.whoami)
      .then((response) => {
        if (isMounted) {
          dispatch(setUser({ ...response.data }));
        }
      })
      .catch(() => {})
      .finally(() => {
        if (isMounted) {
          setAuthReady(true);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [dispatch, user]);

  return authReady;
}
